import { Link } from '@mui/material';
import React from 'react';

export const ContactMarexEmail = () => {
    return <Link href="mailto:neon@marex.com">neon@marex.com</Link>;
};
